import React from 'react';
import { X, Building2, Mail, Phone, MapPin, BadgeDollarSign, Image as ImageIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import '../AddFournisseurDialog/AddFournisseurDialog.css';

const ViewCentreDialog = ({ isOpen, onClose, centre }) => {
  const { t } = useTranslation();

  if (!isOpen || !centre) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay ui-dialog-overlay" onClick={handleOverlayClick}>
      <div className="dialog-container ui-dialog-container">
        <div className="dialog-header ui-dialog-header">
          <div className="dialog-title ui-dialog-title">
            <Building2 size={24} />
            <h2>{t('centres.viewDialog.title', { defaultValue: 'Détails du centre' })}</h2>
          </div>
          <button className="dialog-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="dialog-form">
          <div className="form-group">
            <label className="ui-label">
              <Building2 size={16} />
              {t('centres.dialog.form.name')}
            </label>
            <input type="text" value={centre.name || '-'} readOnly className="ui-input" />
          </div>

          <div className="form-group">
            <label className="ui-label">
              <MapPin size={16} />
              {t('centres.dialog.form.address')}
            </label>
            <textarea value={centre.address || '-'} readOnly rows={2} className="ui-textarea" />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label className="ui-label">
                <Mail size={16} />
                {t('centres.dialog.form.email')}
              </label>
              <input type="text" value={centre.email || '-'} readOnly className="ui-input" />
            </div>
            <div className="form-group">
              <label className="ui-label">
                <Phone size={16} />
                {t('centres.dialog.form.phone')}
              </label>
              <input type="text" value={centre.phone || '-'} readOnly className="ui-input" />
            </div>
          </div>

          {/* Champ devise masqué - la devise du fournisseur est utilisée à la place
          <div className="form-group">
            <label className="ui-label">
              <BadgeDollarSign size={16} />
              Devise
            </label>
            <input type="text" value={centre.devise || '-'} readOnly className="ui-input" />
          </div>
          */}

          <div className="form-group">
            <label className="ui-label">
              <ImageIcon size={16} />
              Logo
            </label>
            {centre.logo ? (
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                <img
                  src={centre.logo}
                  alt="logo"
                  style={{ maxWidth: '180px', maxHeight: '120px', objectFit: 'contain', borderRadius: '8px', border: '1px solid #e5e7eb', padding: '6px', background: '#fff' }}
                />
                <a href={centre.logo} target="_blank" rel="noreferrer" className="view-value link">
                  {centre.logo}
                </a>
              </div>
            ) : (
              <input type="text" value="-" readOnly className="ui-input" />
            )}
          </div>

          <div className="dialog-actions ui-dialog-actions">
            <button type="button" className="btn-secondary ui-btn-secondary" onClick={onClose}>
              {t('common.close')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewCentreDialog;
